import image1 from "../../assets/images/pastor-slide3.jpg";
import image2 from "../../assets/images/church7.jpg";
import image3 from "../../assets/images/pastor-alex.jpg";
import image4 from "../../assets/images/slide-children.jpg";
import image5 from "../../assets/images/pastor-slide2.jpg";
import image6 from "../../assets/images/pastor-benjamin.jpg";
import image7 from "../../assets/images/conference.jpg";
import image8 from "../../assets/images/pastor-slide.jpg";
import image9 from "../../assets/images/obligation-pastor.jpg";
import image10 from "../../assets/images/soul-pastor.jpg";

export const slideData = [
  {
    id: "1",
    cart: "Message",
    image: image1,
    title: "The Mountain of Education ",
    names: " Pastor Alex Gyasi MBE",
    utube: "https://www.youtube.com/embed/BWDPWx6DNqM",
  },
  {
    id: "2",
    cart: "Word",
    image: image2,
    title: "What is Sanctification",
    names: " Pastor Alex Gyasi MBE",
    utube: "https://www.youtube.com/embed/JqvJlt-4gQk",
  },
  {
    id: "3",
    cart: "Word",
    image: image3,
    title: "Living By What is Written",
    names: " Pastor Alex Gyasi MBE",
    utube: "https://www.youtube.com/embed/PYbTDJT49nc",
  },
  {
    id: "4",
    cart: "Soul Winning Series:",
    image: image4,
    title: "Obligation of A Disciple 1",
    names: " Pastor Alex Gyasi MBE",
    utube: "https://www.youtube.com/embed/WBLse_DpKVY",
  },
  {
    id: "5",
    cart: "Soul Winning Series:",
    image: image5,
    title: "Obligation of A Disciple 2",
    names: " Pastor Alex Gyasi MBE",
    utube: "//www.youtube.com/embed/HeAOov1SU5s",
  },
  {
    id: "6",
    cart: "Soul Winning Series:",
    image: image6,
    title: " Friendship and Hospitality",
    names: " Pastor Alex Gyasi MBE",
    utube: "https://www.youtube.com/embed/_Z_blghV9uk",
  },
  {
    id: "7",
    cart: "Soul Winning Series:",
    image: image7,
    title: "Seeds Sown In The Heart",
    names: " Pastor Alex Gyasi MBE",
    utube: "https://www.youtube.com/embed/dlVNheswTYI",
  },
  {
    id: "8",
    cart: "Soul Winning Series:",
    image: image8,
    title: "The Messenger's Attitude",
    names: " Pastor Alex Gyasi MBE",
    utube: "https://www.youtube.com/embed/zXZylyT1ujU",
  },
  {
    id: "9",
    cart: "Soul Winning Series:",
    image: image9,
    title: "The Messenger's Message",
    names: " Pastor Alex Gyasi MBE",
    utube: "hhttps://www.youtube.com/embed/zjeQDqbVSD0",
  },
  {
    id: "10",
    cart: "Soul Winning Series:",
    image: image10,
    title: "The Value Of Winning A Soul",
    names: " Pastor Alex Gyasi MBE",
    utube: "https://www.youtube.com/embed/NAg3fUq66-o",
  },
];
